export class RegexEntry {
	emailPattern =
		'^[(?-i)a-z(?-i)0-9._%+-]+@[(?-i)a-z(?-i)0-9.-]+\\.[(?-i)a-z(?-i)]{2,10}$';
}
